import React from "react";
import { makeStyles, MenuItem, Select } from "@material-ui/core";
import { default as UUID } from "node-uuid";

import CueOptions from "./../../Data/CueOptions";

const useStyles = makeStyles((theme) => ({
  songPartSelectWide: {
    width: "24ch",
    marginRight: theme.spacing(1),
  },
  songPartSelectNarrow: {
    width: "12ch",
    marginRight: theme.spacing(1),
  },
}));

function SongPartSelect(props) {
  const classes = useStyles();

  return (
    <Select
      className={props.wide ? classes.songPartSelectWide : classes.songPartSelectNarrow}
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      variant="standard"
      size="small"
      onChange={(event) => props.handlePartChange(event, props.songPart.id)}
      label="The song section"
      defaultValue={props.songPart.part}
    >
      {CueOptions.map((el) => (
        <MenuItem key={UUID.v4()} value={el.part}>
          {el.part}
        </MenuItem>
      ))}
    </Select>
  );
}

export default SongPartSelect;
